import {
    PAYMENT_SLIP_DOWNLOAD_FAILURE,
    PAYMENT_SLIP_ORDER_FAILURE,
    PAYMENT_SLIP_ORDER_SUCCESS,
} from 'store/actions/types';

export const paymentSlipFailure = (error) => {
    return {
        type: PAYMENT_SLIP_ORDER_FAILURE,
        error: error,
    };
};

export const paymentSlipSuccess = (message) => {
    return {
        type: PAYMENT_SLIP_ORDER_SUCCESS,
        message: message,
    };
};

export const downloadPaymentSlipFailure = (error) => {
    return {
        type: PAYMENT_SLIP_DOWNLOAD_FAILURE,
        error: error,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/payment-slip/paymentSlipActions.js